import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "amount-table__table" }
const _hoisted_2 = { key: 0 }

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  heading?: string[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'amount-table',
  props: {
    modifires: { type: [String, Array, Boolean] },
    heading: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(mapModifires)('amount-table', _ctx.modifires))
  }, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("tbody", null, [
        (_ctx.heading)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.heading, (item, i) => {
                return (_openBlock(), _createElementBlock("th", {
                  class: "amount-table__table__th",
                  key: i
                }, _toDisplayString(item), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 2))
}
}

})